import { useLayout } from '@/providers'
import { useBoolVariation } from '@launchdarkly/react-sdk'
import { Box, Stack } from '@mui/material'
import NotificationToasts from '@views/Layout/NotificationToasts/NotificationToasts'
import PageHeader from '@views/Layout/PageHeader/PageHeader'
import { Outlet } from 'react-router-dom'

import AnnouncementBanner from './AnnouncementBanner/AnnouncementBanner'
import AppBar from './AppBar/AppBar'
import ArtemisAgent from './ArtemisAgent/ArtemisAgent'
import Environment from './Environment'
import Sidebar from './Sidebar'

const styles = {
	container: {
		overFlow: 'hidden',
		height: '100vh',
		marginTop: '0',
		display: 'flex',
		width: '100%',
		backgroundColor: (theme) => theme.palette.background.default,
	},
}

/**
 * Root level layout component
 */
export default function Layout() {
	const { appBarHeight, announcementHeight } = useLayout()
	const totalTopOffset = `calc(${appBarHeight} + ${announcementHeight})`
	const notificationsEnabled = useBoolVariation('feature-art-1588-in-app-notifications', false)

	return (
		<Box sx={styles.container}>
			<AnnouncementBanner />
			<AppBar />
			<Sidebar />
			<Environment />
			{notificationsEnabled && <NotificationToasts />}
			<ArtemisAgent topOffset={totalTopOffset} />
			<Stack
				sx={{
					marginTop: totalTopOffset,
					maxHeight: `calc(100% - ${totalTopOffset})`,
					overflow: 'auto',
					width: '100%',
					backgroundColor: 'background.default',
				}}
			>
				<PageHeader />

				<Box overflow="auto">
					<Outlet />
				</Box>
			</Stack>
		</Box>
	)
}
